import { DateTime } from 'luxon';

import { Card } from '../../../../DataDisplay';
import { Group, Stack } from '../../../../Layout';
import { Box } from '../../../../Miscellaneous/Box';
import { Modal, ModalProps } from '../../../../Overlays';
import { Text } from '../../../../Typography';
import { MembershipCard, UIMembership } from '../../../molecules/cards/MembershipCard';

const MembershipDetails = ({
  membership,
  isRedacted,
}: {
  membership?: UIMembership;
  isRedacted?: boolean;
}) => {
  return (
    <Stack>
      <Text fz="lg" fw={600}>
        Membership Details
      </Text>
      <Card
        radius="sm"
        style={(theme) => ({ border: `1px solid ${theme.colors.gray[1]}` })}
        shadow="none"
      >
        <Stack gap="xl">
          <Stack gap="xs">
            <Text fz="sm" fw={600}>
              Name
            </Text>
            {isRedacted ? (
              <Box bg="cobalt.0" h={21} w={221} style={{ borderRadius: 'xs' }}></Box>
            ) : (
              <Text fz="sm" c="gray" tt="capitalize">
                {membership?.first_name} {membership?.last_name}
              </Text>
            )}
          </Stack>
          <Stack gap="xs">
            <Text fz="sm" fw={600}>
              Expiration Date
            </Text>
            {isRedacted ? (
              <Box bg="cobalt.0" h={21} w={76} style={{ borderRadius: 'xs' }}></Box>
            ) : (
              <Text fz="sm" c="gray">
                {DateTime.fromISO(membership?.expires_at).toFormat('MM/dd/yy')}
              </Text>
            )}
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};

interface ViewMembershipModalProps extends ModalProps {
  title?: string;
  showDetails?: boolean;
  membership: UIMembership;
  cta?: React.ReactNode;
}

const ViewMembershipModal = ({
  opened,
  onClose,
  title = 'Membership',
  showDetails,
  membership,
  cta,
}: ViewMembershipModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title} padding="lg">
      <Stack gap="lg">
        <MembershipCard membership={membership} />
        {showDetails && <MembershipDetails membership={membership} />}
        {cta && (
          <Group pt="xs" justify="flex-end">
            {cta}
          </Group>
        )}
      </Stack>
    </Modal>
  );
};

export { MembershipDetails, ViewMembershipModal };
